<template>
    <div :class="[$page.props.auth.check ? 'border-t border-gray-200 dark:border-slate-600 lg:rounded-b-lg' : 'lg:rounded-lg']" class="pb-3 pt-1 px-4 bg-white dark:bg-slate-800 overflow-hidden">
        <form action="#" @submit.prevent="storeComment">
            <div class="flex sm:space-x-3" :class="[$page.props.auth.check ? 'items-start' : 'items-center']">
                <div class="hidden flex-shrink-0 pb-3 pt-3 sm:block">
                    <avatar :user="$page.props.user" class="w-9 h-9"></avatar>
                </div>
                <div :class="{ 'self-center': !$page.props.user }" class="flex-1 min-w-0">
                    <label class="sr-only" for="comment">Comment</label>
                    <div v-if="$page.props.auth.check" class="mr-2 my-3 lg:mr-0">
                        <textarea
                            id="comment"
                            v-model="storeCommentForm.body"
                            :disabled="!post.isPublished"
                            class="block w-full text-sm bg-white dark:bg-slate-600 dark:text-slate-100 border hover:border-gray-300 focus:border-indigo-400 border-transparent rounded-md focus:outline-none resize-none focus:ring-2 focus:ring-indigo-400 dark:placeholder-slate-400"
                            name="comment"
                            :placeholder="placeholder"
                            :rows="textareaRows"
                            @keydown.enter.prevent="handleEnter"
                        ></textarea>
                    </div>
                    <div v-if="!$page.props.auth.check" class="dark:text-slate-50">
                        <Link :href="route('login')" class="text-indigo-500 hover:text-indigo-900 dark:text-indigo-300 dark:hover:text-indigo-400 transition duration-150 ease-in-out"> Sign In</Link>
                        or
                        <Link :href="route('register')" class="text-indigo-500 hover:text-indigo-900 dark:text-indigo-300 dark:hover:text-indigo-400 transition duration-150 ease-in-out"> Sign Up</Link>
                        to leave a comment.
                    </div>
                    <jet-input-error :message="storeCommentForm.errors.body" class="mt-2" />
                </div>
                <jet-button :disabled="storeCommentForm.processing || !post.isPublished" class="place-self-center" size="sm" type="submit">
                    <svg class="-mr-1 w-6 h-6 transform rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                    </svg>
                </jet-button>
            </div>
        </form>
    </div>
</template>

<script>
import JetInputError from "@/Jetstream/InputError"
import JetActionMessage from "@/Jetstream/ActionMessage"
import JetSecondaryButton from "@/Jetstream/SecondaryButton"
import JetDangerButton from "@/Jetstream/DangerButton"
import JetButton from "@/Jetstream/Button"
import AlertWarning from "@/Components/Alerts/Warning"
import Tooltip from "@/Components/Tooltip"

export default {
    components: {
        Tooltip,
        AlertWarning,
        JetButton,
        JetDangerButton,
        JetSecondaryButton,
        JetInputError,
        JetActionMessage,
    },

    props: {
        post: {
            default: null,
            type: Object,
        },
    },

    computed: {
        comments() {
            if (!this.post) return null
            return this.post.comments
        },

        commentCount() {
            if (!this.comments) return 0
            return this.comments.length
        },
        placeholder() {
            return this.commentCount ? "Write a comment" : "Be the first to write a comment!"
        },
    },

    remember: {
        data: ["storeCommentForm"],
        key() {
            return `Post/Comments/CommentForm:${this.post.id}`
        },
    },

    data() {
        return {
            storeCommentForm: this.$inertia.form({
                _method: "POST",
                body: null,
            }),
            deleteCommentForm: this.$inertia.form({}),
            likeCommentForm: this.$inertia.form({}),
            commentBeingDeleted: null,
            reportingComment: null,
            textareaRows: 1,
        }
    },

    methods: {
        confirmDeleteComment(comment) {
            this.commentBeingDeleted = comment
        },

        storeComment() {
            this.storeCommentForm.post(route("posts.comments.store", this.post.id), {
                errorBag: "storeComment",
                preserveScroll: true,
                onSuccess: () => {
                    this.storeCommentForm.reset("body")
                    document.querySelector("#post-comments li:last-child").scrollIntoView()
                },
            })
        },

        deleteComment() {
            this.deleteCommentForm.delete(this.commentBeingDeleted.deleteUrl, {
                errorBag: "deleteComment",
                preserveScroll: true,
                onSuccess: () => (this.commentBeingDeleted = null),
            })
        },

        likeComment(comment) {
            this.likeCommentForm.post(comment.likeUrl, {
                errorBag: "likeComment",
                preserveScroll: true,
            })
        },

        recentLikes(comment) {
            return _.take(comment.likes, 4)
        },

        handleEnter(e) {
            if (e.shiftKey) return this.newline()
            this.storeComment()
        },

        newline() {
            if (this.storeCommentForm.body) {
                if (this.textareaRows < 4) {
                    this.textareaRows = this.textareaRows + 1
                }
                this.storeCommentForm.body = `${this.storeCommentForm.body}\n`
            }
        },
    },
}
</script>
